var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiSrCreditCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_195_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 2.25H3.75C2.7558 2.25119 1.80267 2.64666 1.09966 3.34966C0.396661 4.05267 0.00119089 5.0058 0 6H18C17.9988 5.0058 17.6033 4.05267 16.9003 3.34966C16.1973 2.64666 15.2442 2.25119 14.25 2.25Z",
    fill: "#F86624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.9999C0.00119089 12.9941 0.396661 13.9472 1.09966 14.6502C1.80267 15.3532 2.7558 15.7487 3.75 15.7499H14.25C15.2442 15.7487 16.1973 15.3532 16.9003 14.6502C17.6033 13.9472 17.9988 12.9941 18 11.9999V7.49988H0V11.9999ZM5.25 11.6249C5.25 11.8474 5.18402 12.0649 5.0604 12.2499C4.93679 12.4349 4.76109 12.5791 4.55552 12.6642C4.34995 12.7494 4.12375 12.7717 3.90552 12.7283C3.68729 12.6848 3.48684 12.5777 3.3295 12.4204C3.17217 12.263 3.06502 12.0626 3.02162 11.8443C2.97821 11.6261 3.00049 11.3999 3.08564 11.1944C3.17078 10.9888 3.31498 10.8131 3.49998 10.6895C3.68499 10.5659 3.9025 10.4999 4.125 10.4999C4.42337 10.4999 4.70952 10.6184 4.9205 10.8294C5.13147 11.0404 5.25 11.3265 5.25 11.6249Z",
    fill: "#F86624"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_195_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiSrCreditCard);
export default __webpack_public_path__ + "static/media/fi-sr-credit-card.c430d8db3c63a8fd726b944adcf157b2.svg";
export { ForwardRef as ReactComponent };